import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import type { AgentResponse } from '@timelyapp/integration-cloud-api-spec';

export interface TicAiAgentState {
  request_in_progress: boolean;
  user_prompt: string | null;
  ai_response: AgentResponse | null;
}

const initialState: TicAiAgentState = {
  request_in_progress: false,
  user_prompt: null,
  ai_response: null,
};

const ticAiAgentSlice = createSlice({
  name: 'ticAiAgent',
  initialState,
  reducers: {
    setUserPrompt: (state, { payload }: PayloadAction<string | null>) => {
      state.user_prompt = payload;
      state.request_in_progress = true;
    },
    setAiResponse: (state, { payload }: PayloadAction<AgentResponse>) => {
      state.ai_response = payload;
      state.request_in_progress = false;
    },
    setRequestInProgress: (state, { payload }: PayloadAction<boolean>) => {
      state.request_in_progress = payload;
    },
    clearAiAgentState: state => {
      state.ai_response = null;
      state.user_prompt = null;
      state.request_in_progress = false;
    },
  },
  selectors: {
    getAiResponse: (state: TicAiAgentState) => state.ai_response,
    getUserPrompt: (state: TicAiAgentState) => state.user_prompt,
    getRequestInProgress: (state: TicAiAgentState) => state.request_in_progress,
  },
});

export const { setUserPrompt, setAiResponse, setRequestInProgress, clearAiAgentState } =
  ticAiAgentSlice.actions;
export const { getAiResponse, getUserPrompt, getRequestInProgress } = ticAiAgentSlice.selectors;

export default ticAiAgentSlice.reducer;
